import { InterestFree } from "../../../Components/Components";

const Data = [
    {
        id: "/dental-emergency/",
        slug: "/dental-emergency/",
        pageTitle: "Dental Emergency",
        content: [
            {
                id: "dentalEmergency-sec-1",
                grid: [
                    {
                        id: "dentalEmergency-sec-1.grid1.1",
                        title: "Dental Emergency",
                        titleType:"h3",
                        para: [`Nothing is worse than having an issue with your tooth. The pain which can be experienced can often be excruciating, plus some tooth problems can be quite dangerous, when you’ve got dental emergency, it is extremely important that you look into the problem as soon as you can and seek treatment from a dentist.`, `Carrum Downs Dental Group’s policy is to cater for all dental emergencies during our working hours. Our dentists take the best effort to see all dental emergencies with immediate or same day appointments. Carrum Down’s dental emergency service covers wide areas of South Eastern suburbs of Melbourne.`],
                        list: []
                    },
                    {
                        id: "dentalEmergency-sec-1.grid1.2",
                        title: "Some of the common dental emergencies include:",
                        titleType:"h3",
                        para: [],
                        list: [
                            { id: "dentalEmergency-sec-1.grid1.2.list.1", text: "Broken Teeth" },
                            { id: "dentalEmergency-sec-1.grid1.2.list.2", text: "Knocked Out Teeth" },
                            { id: "dentalEmergency-sec-1.grid1.2.list.3", text: "Abscess or Swelling" },
                            { id: "dentalEmergency-sec-1.grid1.2.list.4", text: "Lost or Broken Dentures" },
                            { id: "dentalEmergency-sec-1.grid1.2.list.5", text: "Lost or Broken Fillings" },
                            { id: "dentalEmergency-sec-1.grid1.2.list.6", text: "Broken Crown" },
                            { id: "dentalEmergency-sec-1.grid1.2.list.7", text: "Broken or Loose Implants" },
                            { id: "dentalEmergency-sec-1.grid1.2.list.8", text: "Impacted or Wisdom tooth" },
                        ]
                    }
                ],
                para:[],
                component: null,
                sec:[]
            },{
                id:"dentalEmergency-sec-2",
                grid:[],
                para:[],
                component: <InterestFree />,
                sec:[]
            },
            {
                id:"dentalEmergency-sec-3",
                grid:[],
                para:[`Carrum Downs Dental Group’s policy is to cater for all dental emergencies during our working hours. Our dentists take the best effort to see all dental emergencies with immediate or same day appointments. Carrum Down’s dental emergency service covers wide areas of South Eastern suburbs of Melbourne.`,`If you are in a dental emergency and in need of immediate dental care, please call our clinic on (03) 9782 1200 to book your dental appointment. Carrum Downs Dental is happy to serve on your dental emergency without any extra cost.`],
                component: null,
                sec:[]
            }
        ],
        seo: [
            {
                title:"Dental Emergency -",
                description:""
            }
        ]
    }
];

export default Data;